import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useInfoButtonStyles } from "./css";
import { HelpOutlineOutlined } from "@mui/icons-material";

interface ICheckboxExampleState {
  text: string;
}

function InfoButton(props: ICheckboxExampleState) {
  const { text } = props;
  const { classes } = useInfoButtonStyles();
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Tooltip open={open} onClose={handleClose} title={text}>
      <IconButton onClick={handleClick} className={classes.root}>
        <HelpOutlineOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export default InfoButton;
